var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.common.loading)?_c('Loading'):_vm._e(),(_vm.common.dialog.open)?_c('Dialog'):_vm._e(),_c('Toast'),_c('SellerCenterFloatingBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }